import { apiRequest } from './client';
import { PosterKind, Role, User } from '../types';
import { getDeviceFingerprint } from '../utils/deviceId';

export interface AuthResponse {
  accessToken: string;
  user: User;
}

export async function register(
  email: string,
  password: string,
  name: string,
  role: Role,
  posterKind?: PosterKind,
  referralCode?: string,
) {
  const deviceFingerprint = await getDeviceFingerprint();
  return apiRequest<AuthResponse>('/auth/register', {
    method: 'POST',
    body: { email, password, name, role, posterKind, referralCode: referralCode || undefined, deviceFingerprint },
  });
}

export function login(email: string, password: string) {
  return apiRequest<AuthResponse>('/auth/login', {
    method: 'POST',
    body: { email, password },
  });
}

export function me(token: string) {
  return apiRequest<User>('/users/me', { token });
}

/** Adds the OTHER role capability to the current account (reviewer <-> shop
 * owner) — returns a fresh token that already reflects it, no re-login needed. */
export function addRole(token: string, role: Role, posterKind?: PosterKind) {
  return apiRequest<AuthResponse>('/auth/add-role', { method: 'POST', token, body: { role, posterKind } });
}

/** Bumps the account's tokenVersion server-side so this (and every other
 * already-issued) token stops working immediately, instead of staying valid
 * until its 7-day expiry. */
export function logout(token: string) {
  return apiRequest<void>('/auth/logout', { method: 'POST', token });
}

/** Always resolves the same way whether or not the email is registered —
 * see AuthService.requestPasswordReset. devOtpCode is only ever present
 * when no real SMTP provider is configured (dev/test). */
export function forgotPassword(email: string) {
  return apiRequest<{ devOtpCode?: string } | void>('/auth/forgot-password', {
    method: 'POST',
    body: { email },
  });
}

export function resetPassword(email: string, code: string, newPassword: string) {
  return apiRequest<AuthResponse>('/auth/reset-password', {
    method: 'POST',
    body: { email, code, newPassword },
  });
}
